import { urls } from "../api/api.urls";
import makeUploadRequest from "../api/make.upload";

export class AutoUploadService {
    static async uploadPdf(formData: any) {
        return makeUploadRequest(urls.upload.uploadPdfQuestion, "post", formData);
    }
}